var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 1.1547C13.4876 0.440169 15.0124 0.440169 16.25 1.1547L24.3744 5.8453C25.612 6.55983 26.3744 7.88034 26.3744 9.3094V18.6906C26.3744 20.1197 25.612 21.4402 24.3744 22.1547L16.25 26.8453C15.0124 27.5598 13.4876 27.5598 12.25 26.8453L4.12564 22.1547C2.88804 21.4402 2.12564 20.1197 2.12564 18.6906V9.3094C2.12564 7.88034 2.88804 6.55983 4.12564 5.8453L12.25 1.1547Z",
    fill: "url(#paint0_linear_870_1252)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 3.1547C13.4876 2.44017 15.0124 2.44017 16.25 3.1547L22.6423 6.8453C23.8799 7.55983 24.6423 8.88034 24.6423 10.3094V17.6906C24.6423 19.1197 23.8799 20.4402 22.6423 21.1547L16.25 24.8453C15.0124 25.5598 13.4876 25.5598 12.25 24.8453L5.8577 21.1547C4.62009 20.4402 3.8577 19.1197 3.8577 17.6906V10.3094C3.8577 8.88034 4.62009 7.55983 5.8577 6.8453L12.25 3.1547Z",
    fill: "url(#paint1_linear_870_1252)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 4.1547C13.4876 3.44017 15.0124 3.44017 16.25 4.1547L21.7763 7.3453C23.0139 8.05983 23.7763 9.38034 23.7763 10.8094V17.1906C23.7763 18.6197 23.0139 19.9402 21.7763 20.6547L16.25 23.8453C15.0124 24.5598 13.4876 24.5598 12.25 23.8453L6.72372 20.6547C5.48612 19.9402 4.72372 18.6197 4.72372 17.1906V10.8094C4.72372 9.38034 5.48612 8.05983 6.72372 7.3453L12.25 4.1547Z",
    fill: "url(#paint2_linear_870_1252)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 6.1547C13.4876 5.44017 15.0124 5.44017 16.25 6.1547L20.0442 8.3453C21.2818 9.05983 22.0442 10.3803 22.0442 11.8094V16.1906C22.0442 17.6197 21.2818 18.9402 20.0442 19.6547L16.25 21.8453C15.0124 22.5598 13.4876 22.5598 12.25 21.8453L8.45577 19.6547C7.21817 18.9402 6.45577 17.6197 6.45577 16.1906V11.8094C6.45577 10.3803 7.21817 9.05983 8.45577 8.3453L12.25 6.1547Z",
    fill: "url(#paint3_linear_870_1252)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4619 16.3408C17.4619 17.3115 17.1429 18.0316 16.5049 18.501C15.8714 18.9658 14.9987 19.1982 13.8867 19.1982C13.0938 19.1982 12.4215 19.0547 11.8701 18.7676C11.3232 18.4759 10.9336 18.109 10.7012 17.667L12.2529 16.6074C12.4215 16.8672 12.6312 17.0768 12.8818 17.2363C13.1325 17.3958 13.4743 17.4756 13.9072 17.4756C14.4541 17.4756 14.8506 17.3708 15.0967 17.1611C15.3473 16.9515 15.4727 16.6302 15.4727 16.1973C15.4727 15.3223 14.8939 14.8848 13.7363 14.8848H12.8955V13.2305H13.627C14.2057 13.2305 14.6273 13.1165 14.8916 12.8887C15.1559 12.6608 15.2881 12.3646 15.2881 12C15.2881 11.7311 15.1924 11.5078 15.001 11.3301C14.8096 11.1523 14.4951 11.0635 14.0576 11.0635C13.6201 11.0635 13.2692 11.1341 13.0049 11.2754C12.7451 11.4121 12.5218 11.6217 12.335 11.9043L10.7969 10.8242C11.1706 10.3184 11.6217 9.94466 12.1504 9.70312C12.6836 9.46159 13.3672 9.34082 14.2012 9.34082C14.8346 9.34082 15.3861 9.44108 15.8555 9.6416C16.3294 9.83757 16.6872 10.111 16.9287 10.4619C17.1702 10.8128 17.291 11.2139 17.291 11.665C17.291 12.9001 16.653 13.6748 15.377 13.9893C16.0013 14.0303 16.5049 14.2673 16.8877 14.7002C17.2705 15.1286 17.4619 15.6755 17.4619 16.3408Z",
    fill: "#CA7425"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_870_1252",
    x1: 0.25,
    y1: 0,
    x2: 28.25,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8E1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4AC79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_870_1252",
    x1: 2.25,
    y1: -7.94729e-8,
    x2: 26.25,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1A168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAE1CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_870_1252",
    x1: 6.25,
    y1: 1.5,
    x2: 22.75,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D49050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA7425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_870_1252",
    x1: 5.25,
    y1: 5,
    x2: 21.9,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8E4CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBC39F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThree);
export default __webpack_public_path__ + "static/media/three.8ec0d9d283248f0d1155ec30c8e0237f.svg";
export { ForwardRef as ReactComponent };